import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Check } from "lucide-react";
import { motion } from "framer-motion";
import { toast } from "sonner";

const plans = [
  {
    tag: "ACCESSO ANTICIPATO",
    tagColor: "text-muted-foreground",
    name: "Per chi vuole essere tra i primi",
    price: "€10",
    priceNote: "una tantum",
    features: [
      "15 minuti delle tue storie",
      "Dialoghi testuali",
      "Fino a 10 domande al giorno",
      "Partecipazione allo sviluppo",
    ],
    cta: "Riserva il Tuo Posto",
    variant: "outline-primary",
    featured: false,
  },
  {
    tag: "FAMIGLIA",
    tagColor: "text-success",
    name: "Per la vera memoria tra generazioni",
    price: "€100",
    priceNote: "una tantum",
    features: [
      "60 minuti della tua voce",
      "Dialoghi vocali",
      "Fino a 5 membri della famiglia",
      "50 dialoghi gratuiti/mese",
      "App mobile",
    ],
    cta: "Pre-ordina con Sconto",
    variant: "warm",
    featured: true,
  },
  {
    tag: "PREMIUM",
    tagColor: "text-accent",
    name: "Trasmissione profonda. Per sempre.",
    price: "Su richiesta",
    priceNote: "",
    features: [
      "Server personale",
      "Intervista di 5 ore",
      "Utenti illimitati",
      "1000 dialoghi",
      "Supporto prioritario",
    ],
    cta: "Prenota una Consulenza",
    variant: "premium",
    featured: false,
  },
];

export const PricingSection = () => {
  const handleSelect = (planName) => {
    toast.success(`Hai selezionato il piano ${planName}!`, {
      description: "Ti contatteremo presto per procedere.",
    });
  };

  return (
    <section id="prezzi" className="py-24 lg:py-32 relative">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground leading-tight">
            Scegli il formato più adatto a te
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {plans.map((plan, index) => (
            <motion.div
              key={plan.tag}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: index * 0.12 }}
            >
              <Card className={`relative h-full transition-all duration-500 ${
                plan.featured
                  ? "bg-card border-success/30 shadow-elevated"
                  : "bg-card border-border/40 shadow-card hover:shadow-medium"
              }`}>
                <CardContent className="p-8 flex flex-col h-full">
                  {/* Tag */}
                  <span className={`text-xs font-bold tracking-widest uppercase ${plan.tagColor} mb-4`}>
                    {plan.tag}
                  </span>

                  {/* Name */}
                  <h3 className="font-serif text-lg font-bold text-foreground mb-4 leading-snug">
                    {plan.name}
                  </h3>

                  {/* Price */}
                  <div className="mb-6">
                    <span className="font-serif text-4xl font-bold text-foreground">{plan.price}</span>
                    {plan.priceNote && <span className="text-sm text-muted-foreground ml-2">{plan.priceNote}</span>}
                  </div>

                  {/* Features */}
                  <div className="space-y-3 mb-8 flex-1">
                    {plan.features.map((feature, i) => (
                      <div key={i} className="flex items-start gap-3">
                        <div className="w-5 h-5 rounded-full bg-success/15 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <Check className="w-3 h-3 text-success" />
                        </div>
                        <span className="text-sm text-foreground">{feature}</span>
                      </div>
                    ))}
                  </div>

                  {/* CTA */}
                  <Button
                    variant={plan.variant}
                    size="lg"
                    className="w-full mt-auto"
                    onClick={() => handleSelect(plan.tag)}
                  >
                    {plan.cta}
                  </Button>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
